import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const WalletTransactionList = ({
  transactions = [],
  loading = false,
  emptyMessage = 'No transactions found.',
  className = '',
  renderItem = () => <></>,
  keyExtractor = (item, index) => item?.id || index
}) => {
  if (loading) {
    return (
      <div className={`wallet-transaction-list ${className}`}>
        {[1, 2, 3].map(item => (
          <div key={item} className="wallet-transaction-list__skeleton" />
        ))}
      </div>
    );
  }

  if (!transactions.length) {
    return <div className="wallet-transaction-list__empty">{emptyMessage}</div>;
  }

  return (
    <div className={`wallet-transaction-list ${className}`}>
      {transactions.map((transaction, index) => (
        <React.Fragment key={keyExtractor(transaction, index)}>
          {renderItem(transaction, index)}
        </React.Fragment>
      ))}
    </div>
  );
};

WalletTransactionList.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      date: PropTypes.string,
      amount: PropTypes.number,
      type: PropTypes.string
    })
  ),
  loading: PropTypes.bool,
  emptyMessage: PropTypes.string,
  className: PropTypes.string,
  renderItem: PropTypes.func.isRequired,
  keyExtractor: PropTypes.func
};

export default WalletTransactionList;
